import { render, staticRenderFns } from "./AuthorizedTemporary.vue?vue&type=template&id=7264983f&scoped=true"
import script from "./AuthorizedTemporary.vue?vue&type=script&lang=js"
export * from "./AuthorizedTemporary.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedTemporary.vue?vue&type=style&index=0&id=7264983f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7264983f",
  null
  
)

export default component.exports